import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useNavigate, useParams } from 'react-router-dom'
import { Image, Trash3, Eye, EyeSlash } from 'react-bootstrap-icons'
import axiosService from '../../../../../../utils/AxiosService'
import { toastSuccess, toastError } from '../../../../../FormComponents/Toasts'
import { useReadOnly } from '../../../../../../contexts/ReadOnlyContext'

export default observer(function ActionItem({ action }) {
  const readOnly = useReadOnly()
  const { id, action_id } = useParams()
  const navigate = useNavigate()

  const displayUploadCount = () => {
    if (action.draft_uploads.length === 0) {
      return "Empty"
    } else if (action.draft_uploads.length === 1) {
      return `${action.draft_uploads.length} Upload`
    } else {
      return `${action.draft_uploads.length} Uploads`
    }
  }

  const updateActionVisibility = () => {
    axiosService.patch(`/api/project_manager/campaigns/${id}/actions/${action.id}`, { action_data: { draft_is_visible: !action.draft_is_visible }})
    .then(updatedAction => {
      action.draft_is_visible = updatedAction.draft_is_visible
      toastSuccess(action.draft_is_visible ? 'Draft is visible to advertiser' : 'Draft is hidden from advertiser')
    })
    .catch((error) => toastError(error))
  }

  return (
    <div
      className={`${action_id && +action_id === +action.id ? 'border-2 border-rb-green dark:border-rb-green bg-rb-soft-green dark:bg-rb-dark-mode-lighter' : 'border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter hover:cursor-pointer hover:shadow-md hover:transform hover:scale-102 transition-all duration-200 dark:bg-rb-dark-mode'} cursor-pointer flex items-center p-2 w-full rounded-lg mb-2 relative`}
      onClick={() => {
        navigate(`/project_manager/campaigns/${id}/draft_process/participants/${action.influencer_id}/actions/${action.id}`)
      }}
    >
      <div className='flex gap-2 items-center'>
        {
          action.draft_uploads.length > 0 && (action.draft_uploads[0].videoThumb || action.draft_uploads[0].url) ? (
            <img key={action.draft_uploads[0].url || action.draft_uploads[0].id} src={action.draft_uploads[0].videoThumb || action.draft_uploads[0].url} alt={action.username} className="h-12 w-12 rounded-lg object-cover" />
          ) : (
            <div className={`${action_id && +action_id === +action.id ? 'border-1 border-rb-green dark:border-rb-green bg-white dark:bg-rb-dark-mode' : 'bg-gray-100 dark:bg-rb-dark-mode-lighter'} h-12 w-12 flex items-center justify-center rounded-md`}>
              <Image className={`${action_id && +action_id === +action.id ? 'text-rb-green dark:text-rb-green' : 'text-gray-200 dark:text-gray-400'} text-2xl`} />
            </div>
          )
        }
        <div className='w-[170px]'>
          <div className="flex gap-2 items-center">
            <h4 className='text-md font-bold dark:text-white'>{action.name}</h4>
          </div>
          <span className={`text-sm font-semibold ${action_id && +action_id === +action.id ? 'text-rb-green dark:text-rb-green' : 'text-gray-300 dark:text-gray-400'}`}>
            { displayUploadCount() }
          </span>
        </div>
      </div>
      <button
        className={`ml-auto mb-auto ${readOnly ? 'cursor-default' : ''}`}
        disabled={readOnly}
        onClick={(e) => {
          e.stopPropagation()
          updateActionVisibility()
        }}
      >
        {action.draft_is_visible ? <Eye className='text-blue-500 dark:text-blue-400' /> : <EyeSlash className='text-gray-500 dark:text-gray-400' />}
      </button>
      {action.draft_is_visible && action.advertiser_approved && <p className='text-xs font-semibold text-rb-green dark:text-rb-green absolute bottom-1 right-1'>Adv. Approved</p>}
    </div>
  )
})
